/**
 * Copy for the out-of-iterations surfaces.
 *
 * Shared by the overlay on / and /refine and the modal in the gallery, which
 * say the same thing in three places and must not drift apart.
 */
export const OUT_OF_ITERATIONS_TITLE = "You're out of Visualizations.";

export const OUT_OF_ITERATIONS_BODY =
  "Your plan will reset on the first of next month. If you can't wait, upgrade to a Pro Plan!";

export const UPGRADE_CTA = "Upgrade Plan";

/** CTA on the header pill, which sits alongside a remaining-iterations count. */
export const SIGN_UP_CTA = "Sign up for a Pro Plan";
